import React from "react";
import ItemScrollPromo from "../ItemScrollPromo";
import ItemScrollProduct from "../ItemScrollProduct";
import MultiCarousel from "../MultiCarouselElements/MultiCarousel";
import MultiCarouselArrows from "../MultiCarouselElements/MultiCarouselArrows";

const ItemSlider = ({ items, itemType, cssBlock, color, buttonColor }) => {

    const responsive = {
        desktop: {
            breakpoint: { max: 9999, min: 1024 },
            items: 4,
            slidesToSlide: 4,
            partialVisibilityGutter: 0
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 2,
            slidesToSlide: 2,
            partialVisibilityGutter: 0
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
            slidesToSlide: 1,
            partialVisibilityGutter: 120
        }
    };

    const showNextItem = items.length > 1;
    const smallTitle = items.length > 2 ? "--small-title" : "";

    const settings = {
        swipeable: true,
        draggable: false,
        showDots: false,
        responsive: responsive,
        containerClass: `${cssBlock}__slider-container`,
        itemClass: `${cssBlock}__slider-item`,
        keyBoardControl: true,
        infinite: false,
        arrows: false,
        customButtonGroup: <MultiCarouselArrows cssBlock={cssBlock} color={color}/>,
        buttonColor: buttonColor,
        renderButtonGroupOutside: true,
        partialVisible: showNextItem
    }

    const variantType = "variant";

    const renderSwitch = (item, index) => {
        switch (itemType) {
            case "product":
                return <ItemScrollProduct item={item} index={index} key={index} color={color} buttonColor={buttonColor} />;
            case "promo":
            default:
                return <ItemScrollPromo item={item} index={index} key={index} smallTitle={smallTitle} />;
        }
    };

    const sortItems = (a, b) => {
        if (itemType !== variantType) return;

        if (a.isActive === b.isActive) return 0;
        else return a.isActive ? -1 : 1;
    };

    const children = (items) => {
        return (
            items.sort(sortItems).map((item, index) => (
                renderSwitch(item, index, itemType, color)
            ))
        )
    };
    return (
        <MultiCarousel settings={settings} children={children(items)} items={items} cssBlock={cssBlock} color={color} />
    );
};
export default ItemSlider;